import { useEffect, useState } from "react";

/** `window.innerWidth < px`, re-read on resize (debounced like the prototype's redraws). */
export function useNarrow(px: number, debounceMs = 200): boolean {
  const read = () => (typeof window === "undefined" ? false : window.innerWidth < px);
  const [narrow, setNarrow] = useState(read);
  useEffect(() => {
    let t: ReturnType<typeof setTimeout> | undefined;
    const onResize = () => {
      clearTimeout(t);
      t = setTimeout(() => setNarrow(window.innerWidth < px), debounceMs);
    };
    window.addEventListener("resize", onResize, { passive: true });
    return () => {
      clearTimeout(t);
      window.removeEventListener("resize", onResize);
    };
  }, [px, debounceMs]);
  return narrow;
}
